


























import Vue from 'vue'
export default Vue.extend({
  methods: {
    resend (): void {
      this.$emit('resend')
    },
    cancel (): void {
      this.$emit('cancel')
    }
  }
})
